import React from 'react';

export interface SplotchProps {
  /** Splotch variant 1-5, each shape is slightly different for visual rhythm. */
  variant?: 1 | 2 | 3 | 4 | 5;
  /** Width in px. Height auto-scales to preserve aspect ratio. */
  size?: number;
  /** 0 - 1 opacity. */
  opacity?: number;
  /** Rotation in degrees. */
  rotate?: number;
  className?: string;
  style?: React.CSSProperties;
}

/** Yellow brand splotch — decorative background art. Real brand asset, used
 *  sparingly behind illustrations and as a structural accent. The PNG is
 *  yellow on transparent; no recoloring. */
export const Splotch: React.FC<SplotchProps> = ({
  variant = 1,
  size = 200,
  opacity = 1,
  rotate = 0,
  className,
  style,
}) => {
  return (
    <img
      src={`/brand/splotch-${variant}.png`}
      alt=""
      aria-hidden="true"
      className={className}
      style={{
        width: size,
        height: 'auto',
        pointerEvents: 'none',
        opacity,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    />
  );
};
